<template>
  <div class="require">
    <div class="page-width">
      <div class="title">
        <h2>
          <span class="tit-l">
            <img src="@/assets/images/new-img/driver/tit-l.png" width="34" />
          </span>司机要求
          <span class="tit-r">
            <img src="@/assets/images/new-img/driver/tit-r.png" width="35" />
          </span>
        </h2>
      </div>
      <div class="require-list">
        <dl>
          <dt>
            <img src="@/assets/images/new-img/driver/require-icon-1.png" width="116" />
          </dt>
          <dd class="name">车辆要求</dd>
          <dd class="info">自有带车、不带车，均可；带车（金杯车、商务车、依维柯/全顺、冷链车、箱式货车）车辆净空≥6方</dd>
        </dl>
        <!-- <dl class="wit">
          <dt>
            <img src="@/assets/images/new-img/driver/require-icon-2.png" width="116" />
          </dt>
          <dd class="name">工作半天制</dd>
          <dd class="info">给市中小型饭店、餐馆配送生鲜食材，工作半天制。</dd>
        </dl> -->
        <dl>
          <dt>
            <img src="@/assets/images/new-img/driver/require-icon-3.png" width="116" />
          </dt>
          <dd class="name">驾龄在一年以上</dd>
          <dd class="info">年龄55岁以下者优先，驾驶证、行驶证、保险等证件齐全</dd>
        </dl>
        <dl>
          <dt>
            <img src="@/assets/images/new-img/driver/require-icon-4.png" width="116" />
          </dt>
          <dd class="name">基本要求</dd>
          <dd class="info">身体健康、能吃苦耐劳、品行端正、执行力强、会用智能手机</dd>
        </dl>
        <dl>
          <dt>
            <img src="@/assets/images/new-img/driver/require-icon-5.png" width="116" />
          </dt>
          <dd class="name">服务意识</dd>
          <dd class="info">熟悉城市道路、以客户第一为导向，有强烈的客户服务意识、一切围绕客户信赖为导向</dd>
        </dl>
      </div>
      <div class="tips">
        现面向各城市招募司机，城市包括：
        {{cityList}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "conditions",
  data() {
    return {
      cityList: ""
    };
  },
  methods: {
    getcityList() {
      _api.all.getRegisterCity().then(res => {
        this.cityList = res.data.map(i => {
          return i.name;
        });
        this.cityList = this.cityList.join('、')
      });
    }
  },
  mounted() {
    this.getcityList()
  }
};
</script>

<style lang="scss" scoped>
.require {
  background: #fff;
  padding: 75px 0;
  .title {
    height: 100px;
    h2 {
      font-size: 34px;
      position: relative;
      width: 300px;
      margin: 0 auto;
      text-align: center;
      .tit-l {
        position: absolute;
        left: 0;
        top: 15px;
      }
      .tit-r {
        position: absolute;
        right: 0;
        top: 2px;
      }
    }
  }
  dl {
    width: 268px;
    text-align: center;
    dd.name {
      margin-top: 40px;
      font-size: 22px;
      color: #4a4a4a;
    }
    dd.info {
      text-align: justify;
      color: #757575;
      line-height: 1.8;
      margin-top: 15px;
      padding: 0 16px;
      font-size: 13px;
    }
  }
  dl.wit {
    width: 190px;
  }
  .tips {
    clear: both;
    font-size: 18px;
    padding-top: 60px;
    line-height: 1.8;
  }
}
.require-list {
  display: flex;
}
</style>
